import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

import "../styles/CompanyRegionalityVizStyles.css";

const Pie = (props) => {
  const ref = useRef(null);
  const cache = useRef(props.data);
  const createPie = d3
    .pie()
    .value((d) => d.value)
    .sort(null);
  const createArc = d3
    .arc()
    .innerRadius(props.innerRadius)
    .outerRadius(props.outerRadius);
  const colors = d3.scaleOrdinal(props.colors);
  const format = d3.format(".1f");

  // const div = d3
  //   .select("body")
  //   .append("div")
  //   .attr("id", "yoyoyoy")
  //   .attr("class", "tooltip")
  //   .style("opacity", 0);

  useEffect(() => {
    const data = createPie(props.data);
    const prevData = createPie(cache.current);
    const group = d3.select(ref.current);
    const groupWithData = group.selectAll("g.arc").data(data);

    groupWithData.exit().remove();

    const groupWithUpdate = groupWithData
      .enter()
      .append("g")
      .attr("class", "arc");

    const path = groupWithUpdate
      .append("path")
      .merge(groupWithData.select("path.arc"))
      // .on("mouseover", function (d) {
      //   div.transition().style("opacity", 0.9);
      //   div
      //     .html(
      //       d.data.regionName +
      //         "<br/>" +
      //         "<h1 style='font-weight:300;'>" +
      //         format(d.value * 100) +
      //         "%</h1>"
      //     )
      //     .style("left", d3.event.pageX + 10 + "px")
      //     .style("top", d3.event.pageY + 10 + "px");
      // })
      // .on("mousemove", function (d) {
      //   div
      //     .html(
      //       d.data.regionName +
      //         "<br/>" +
      //         "<h1 style='font-weight:300;'>" +
      //         format(d.value * 100) +
      //         "%</h1>"
      //     )
      //     .style("left", d3.event.pageX + 10 + "px")
      //     .style("top", d3.event.pageY + 10 + "px");
      // })
      // .on("mouseout", function (d) {
      //   div.transition().style("opacity", 0);
      // });

    const arcTween = (d, i) => {
      const interpolator = d3.interpolate(prevData[i], d);

      return (t) => createArc(interpolator(t));
    };

    path
      .attr("class", "arc")
      .attr("fill", (d, i) => colors(i))
      .transition()
      .attrTween("d", arcTween);

    // const text = groupWithUpdate
    //     .append("text")
    //     .merge(groupWithData.select("text"));

    // text
    //     .attr("text-anchor", "middle")
    //     .attr("alignment-baseline", "middle")
    //     .style("fill", "white")
    //     .style("font-size", 13)
    //     .transition()
    //     .attr("transform", d => `translate(${createArc.centroid(d)})`)
    //     .tween("text", (d, i, nodes) => {
    //         const interpolator = d3.interpolate(prevData[i], d);

    //         return t => d3.select(nodes[i]).text(format(interpolator(t).value * 100) + "%");
    //     });

    cache.current = props.data;

    return function cleanup() {
      d3.selectAll("#yoyoyoy").remove();
    }
  }, [props.data]);

  useEffect(function() {
    return function cleanup() {
      d3.selectAll("#yoyoyoy").remove();
    }
  }, [])


  return (
    <svg
      width={props.width}
      height={props.height}
      style={{ position: "relative" }}
      id="svg"
    >
      <g
        ref={ref}
        transform={`translate(${props.outerRadius} ${props.outerRadius})`}
      />
    </svg>
  );
};

export default Pie;
